// jscs:disable disallowQuotedKeysInObjects
export default {
  'settings.close': 'Close',
  'settings.title': 'Settings',
  'settings.snackbar': 'Please add at least one screen to the rotation list!',
  'screenlauncher.subheader': 'Click to select',
  'screenlauncher.title': 'Go to screen',
  'screenlauncher.close': 'Close',
  'editslideform.form.labels.url': 'Url (required)',
  'editslideform.form.labels.duration': 'Duration in seconds (required)',
  'editslideform.form.validationerrors.url': 'Please enter a valid url',
  'editslideform.form.validationerrors.duration': 'Please enter a valid duration',
  'editslideform.title': 'Edit slide',
  'editslideform.subheader': 'Screen rotation list',
  'editslideform.secondarytext': `{duration, plural,
      one {{duration} second}
      other {{duration} seconds}}`,
  'editslideform.buttons.update': 'Update',
  'editslideform.buttons.cancel': 'Cancel',
  'editslideform.buttons.delete': 'Delete',
  'editslideform.buttons.edit': 'Edit',
  'editslideform.tooltips.more': 'more',
  'iframelocker.snackbar': 'This app runs in read only mode! You cannot interact with the websites that are shown!',
  'exportslides.title': 'Export slides',
  'exportslides.buttons.close': 'Close',
  'exportslides.buttons.copycb': 'Copy to clipboard',
  'importslides.title': 'Import slides',
  'importslides.form.hints.backupjson': 'Copy a previously exported screen rotation list into this field',
  'importslides.form.labels.backupjson': 'Screen rotation list JSON',
  'importslides.form.validationerrors.duration': 'Please enter valid JSON',
  'importslides.buttons.close': 'Close',
  'importslides.buttons.import': 'Import',
  'sync.title': 'Remote database sync settings',
  'sync.message.reboothint': 'Sync settings have been changed and thus junkan needs to reboot!',
  'sync.buttons.close': 'Close',
  'sync.buttons.update': 'Update',
  'sync.form.labels.dburl': 'Url of a pouch db compatible remote database',
  'sync.form.labels.dbuser': 'Remote database user',
  'sync.form.labels.dbpassword': 'Remote database password',
  'sync.form.validationerrors.dburl': 'Please enter a valid url!',
  'sync.form.labels.snycmode': 'Sync mode',
  'sync.form.options.read': 'read',
  'sync.form.options.write': 'write',
  'sync.form.options.readwrite': 'read & write',
  'sync.form.labels.enable': 'Enable sync',
  'reloader.snackbar': 'Restarting junkan when this screen ends'
};



// WEBPACK FOOTER //
// ./src/intl/en.js